<template>
  <b-modal
    @hidden="limpaDados"
    size="lg"
    id="ModalFeedback"
    :no-close-on-backdrop="loading || feedbackTexto.trim().length != 0"
    :no-close-on-esc="loading || feedbackTexto.trim().length != 0"
  >
    <Header
      mini
      titulo="Sua opinião é muito importante!"
      icone="comment"
      cor="azul"
      slot="modal-header"
    />

    <LoadingPadraoContainer
      v-if="loading"
      class="loading-padrao-backdrop"
      background
      :fraseLoading="['Enviando feedback', 'Aguarde um momento']"
      delay="5000"
      classe="azul"
    />
    <div class="modal-feedback-corpo">
      <p>
        Nos ajude a melhorar cada vez mais e realizar alterações relevantes para facilitar o seu
        dia-a-dia no uso dessa ferramenta.
      </p>
      <p>
        Escreva abaixo o seu comentário!
      </p>
      <textarea
        :class="['modal-feedback-texto', { 'modal-feedback-erro': vazio }]"
        v-model="feedbackTexto"
        placeholder="Digite aqui sua sugestão"
      ></textarea>
    </div>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Cancelar"
        icone="times"
        :desabilita="loading"
        :click="cancelar"
      />
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Enviar"
        icone="check"
        :click="handleClick"
        :desabilita="loading"
        cor="azul"
      />
    </template>
  </b-modal>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

import Api from "@/services/api.js";
import { mapGetters } from "vuex";

export default {
  name: "ModalFeedback",
  components: {
    BotaoPadrao,
    Header,
    LoadingPadraoContainer
  },
  inject: ["pushAlert"],
  data() {
    return {
      feedbackTexto: "",
      vazio: false,
      loading: false
    };
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },
  watch: {
    feedbackTexto() {
      if (this.feedbackTexto.trim().length != 0) {
        this.vazio = false;
      }
    }
  },
  computed: {
    ...mapGetters("login", ["getUser"])
  },
  methods: {
    handleKey(event) {
      let modal = document.getElementById("ModalFeedback");
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          this.$root.$emit("bv::hide::modal", "ModalFeedback");
        }
      }
    },
    async handleClick() {
      if (this.feedbackTexto.trim().length == 0) {
        this.vazio = true;
        this.pushAlert("Campo obrigatório", "danger");
        return;
      }
      this.loading = true;
      await this.enviarFeedback();
      this.loading = false;
      this.cancelar();
    },
    cancelar() {
      this.$root.$emit("bv::hide::modal", "ModalFeedback");
    },
    async enviarFeedback() {
      await new Api().post(
        "Feedback/enviarFeedback",
        {
          tx_feedback: this.feedbackTexto.trim(),
          id_cliente: this.getUser.id_usuario
        },
        true
      );
    },
    limpaDados() {
      this.feedbackTexto = "";
      this.vazio = false;
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-feedback-corpo {
  p {
    margin: 0;
    color: var(--cinza2);
    // font-family: "roboto condensed";
    font-weight: 600;
    font-size: 13px;
  }
}
.modal-feedback-texto {
  width: 100%;
  height: 200px;
  border: solid 1px var(--cinza-borda);
  border-radius: 2px;
  resize: none;
  padding: 4px;
  margin-top: 10px;
  transition: border 0.3s ease-in-out;
}
.modal-feedback-erro {
  border: solid 1px var(--vermelho3);
}
</style>
